// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGThumbsDown = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 12",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.124 1.732h1.297c1.178 0 2.134.96 2.134 2.138V7.1c0 .373-.099.737-.283 1.059L6.699 10.91c-.077.133-.219.215-.373.215l.004.004c-.544 0-1.045-.27-1.345-.724-.3-.455-.352-1.025-.138-1.522l.498-1.17h-2.37c-.707 0-1.282-.574-1.282-1.281 0-.33.125-.629.33-.856-.205-.226-.33-.526-.33-.855 0-.59.4-1.088.943-1.238-.055-.146-.09-.304-.09-.471 0-.707.575-1.282 1.282-1.282H5.124zm-.015.856H3.828c-.236 0-.425.193-.425.425 0 .231.193.424.425.424.231 0 .428.193.428.428 0 .236-.193.429-.428.429h-.853c-.236 0-.424.193-.425.424 0 .232.193.425.425.425h.853c.235 0 .428.193.428.428V5.58c0 .235-.193.428-.428.428h-.853c-.236 0-.424.193-.425.425 0 .23.193.424.425.424h3.017c.146 0 .278.073.355.193.082.12.095.27.04.402l-.755 1.766c-.103.236-.077.497.064.716.099.15.24.253.403.304l1.432-2.503c.11-.192.167-.41.167-.634V3.87c0-.707-.575-1.282-1.277-1.282H5.109z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M9.836 1.731c.236 0 .429.193.429.429v5.125c0 .236-.193.429-.429.429s-.428-.193-.428-.429V2.16c0-.236.193-.429.428-.429z"
  })]
}));
SVGThumbsDown.displayName = 'SVGThumbsDown';
export default SVGThumbsDown;